import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class InvoiceFetchAPI {
    //Function to generate a electronic invoice 
    static async generateFE(data) {
        const res = await server("/invoice", {
            method: "post",
            data: {
                invoice_params: data
            }
        });
        return res;
    }

    //Function to generate a electronic invoice 
    static async generateCreditNote(data) {
        const res = await server("/credit_note", {
            method: "post",
            data: {
                credit_note_params: data
            }
        });
        return res;
    }

    static async downloadBulkTemplate(token) {
        const res = await server("/invoice/bulk/template", {
            method: "get",
            responseType: "blob",
            headers: {
                'ushopper-access-token': token
            }
        });
        return res;
    }

    static async previewBulkInvoices(formData, token) {
        const res = await server("/invoice/bulk/preview", {
            method: "post",
            data: formData,
            headers: {
                'Content-Type': "multipart/form-data",
                'ushopper-access-token': token
            }
        });
        return res;
    }

    static async generateBulkInvoices(formData, token) {
        const res = await server("/invoice/bulk/generate", {
            method: "post",
            data: formData,
            headers: {
                'Content-Type': "multipart/form-data",
                'ushopper-access-token': token
            }
        });
        return res;
    }

    static async getBulkInvoiceJob(jobId, token) {
        const res = await server(`/invoice/bulk/jobs/${jobId}`, {
            method: "get",
            headers: {
                'ushopper-access-token': token
            }
        });
        return res;
    }

    static async resendBulkInvoiceEmail(jobId, resultIndex, token) {
        const res = await server(`/invoice/bulk/jobs/${jobId}/results/${resultIndex}/resend-email`, {
            method: "post",
            headers: {
                'ushopper-access-token': token
            }
        });
        return res;
    }
}